import request from "@utils/request";
import { json } from "./json"; // 李明说放到本地
export function getOrderTime(currentTime) {
  return new Promise((r) => {
    r(json);
  });
}

export function get4City() {
  return request({
    method: "GET",
    url: "/power/carChargingOrder/noAuth/front/v3.2.0/get4City",
    params: {},
    headers: {
      Authorization: "null",
    },
  });
}

export function getShopListSimple(params) {
  return request({
    method: "get",
    url: `/maintenance/offlineExperienceShop/noAuth/front/v3.2.4.5/getShopListSimple`,
    // params: {
    //   authorizeCityAdCode: cityCode,
    // },
    params,
    headers: {
      Authorization: "null",
    },
  });
}

export function addDriveAppointment(data) {
  return request({
    method: "post",
    url: `/marketing/carTryDrive/noAuth/front/v3.2.0/addDriveAppointment`,
    data: data,
    headers: {
      Authorization: "null",
    },
  });
}

// 获取试驾配置车系配置
export function testDriveConfig(data) {
  return request({
    method: "get",
    url: `/marketing/testDriveConfig/noAuth/front/ssh/config/get`,
    params: data,
    headers: {
      Authorization: "null",
    },
  });
}

// 发送验证码
export function sendCode(data) {
  return request({
    method: "post",
    url: `/marketing/toolAct/noAuth/front/v3.3.0/sendPhoneCode`,
    data: data,
    headers: {
      Authorization: "null",
    },
  });
}

// 经纬度获取最近门店
export function getDmsShopByCoord(data) {
  console.log(data);
  return request({
    method: "get",
    url: `/maintenance/offlineExperienceShop/noAuth/front/ssh/gaode/getDmsShopByCoord`,
    params: {
      longitude: data.longitude || "",
      latitude: data.latitude || "",
      carSeriesCode: data.carSeriesCode || "",
      carSeriesCodeForAppointed: data.carSeriesCodeForAppointed || "",
    },
  });
}
